import { ComponentFactoryResolver, Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { DesignHostComponent } from '../components/design-host/design-host.component';
import { AbstractControlContainerComponent } from '../controls/abstract-control-container/abstract-control-container.component';
import { ControlLayoutHost, ControlViewModel, DynamicControlContainer, LoadComponentModel } from '../types';
import { AbstractControl, ControlDataModel, ControlLayoutModel } from '../types/control.types';
import { ControlTranslate } from '../utils';
import { DataModelService } from './data-model.service';

@Injectable({ providedIn: 'root' })
export class ControlTranslateService implements ControlTranslate {
  disableOperateControl: boolean;
  /**
   * æ§ä»¶è§£æå®æ
   */
  controlResolved = new Subject<AbstractControl<ControlViewModel>>();

  get controlRemoved$(): Observable<AbstractControl<any>> {
    return this._controlRemoved.asObservable();
  }

  get loadComponentModel$(): Observable<LoadComponentModel> {
    return this._loadByLoadComponentModel.asObservable();
  }

  sendControlRemoved(control: AbstractControl<any>): void {
    this._controlRemoved.next(control);
  }

  sendLoadComponentModel(data: LoadComponentModel): void {
    this._loadByLoadComponentModel.next(data);
  }

  private _loadByLoadComponentModel: Subject<LoadComponentModel>;
  private _controlRemoved: Subject<AbstractControl<any>>;

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private dataModelService: DataModelService) {
    this._loadByLoadComponentModel = new Subject<LoadComponentModel>();
    this._controlRemoved = new Subject<AbstractControl<any>>();
  }

  /**
   *  ä½¿ç¨LoadComponentModelå è½½ç»ä»¶
   *
   */
  loadComponentsByModel(loadModel: LoadComponentModel): AbstractControl<any> | AbstractControl<any>[] {
    let control;
    if (Array.isArray(loadModel.layoutModel)) {
      control = this.loadComponents(
        loadModel.layoutModel as ControlDataModel[],
        loadModel.dynamicControlContainer,
        loadModel.isDesign
      );
    } else {
      control = this.loadComponent(
        loadModel.layoutModel as ControlLayoutModel,
        loadModel.dynamicControlContainer,
        loadModel.isDesign
      );
    }
    if (loadModel.result) {
      loadModel.result(control);
    }

    return control;
  }

  /**
   * @description æ ¹æ®æ§ä»¶DataModelsçææ§ä»¶, å½dataModelsä¸ºç©ºæ¶ï¼è¿åç©ºæ°ç»
   *
   * @param  dataModels è¦çæçæ§ä»¶DataModels
   * @param  viewContainerRef ä¾èµçè§å¾å®¹å¨
   * @param  [isDesign] æ¯å¦æ¯è®¾è®¡æ¶
   * @returns å·²æ·»å çæ§ä»¶éå
   * @memberof ControlTranslateService
   */
  loadComponents(
    dataModels: Array<ControlDataModel>,
    controlLayoutHost: DynamicControlContainer,
    isDesign?: boolean
  ): Array<AbstractControl<ControlViewModel>> {
    const controls: Array<AbstractControl<ControlViewModel>> = [];

    if (!dataModels) {
      return controls;
    }
    const viewContainerRef = controlLayoutHost.layoutHost.viewContainerRef;

    viewContainerRef.clear();

    for (const dataModel of dataModels) {
      const layoutModel: ControlLayoutModel = this.dataModelService.translateDataModel2LayoutModel(dataModel);
      const control = this.loadComponent(layoutModel, controlLayoutHost, isDesign);
      if (control) {
        controls.push(control);
      }
    }

    return controls;
  }

  /**
   * æ ¹æ®æ§ä»¶å¸å±Modelçææ§ä»¶ï¼å¦ælayoutModelä¸ºç©ºï¼åè¿ånull
   *
   * @param  layoutModel æ§ä»¶å¸å±model
   * @param  viewContainerRef ä¾èµçè§å¾å®¹å¨
   * @param  [isDesign] æ¯å¦æ¯è®¾è®¡æ¶
   * @returns å·²æ·»å çæ§ä»¶éå
   * @memberof ControlTranslateService
   */
  loadComponent(
    layoutModel: ControlLayoutModel,
    dynamicControlContainer: DynamicControlContainer,
    isDesign?: boolean
  ): AbstractControl<ControlViewModel> {
    if (layoutModel.component === undefined || layoutModel.component === null) {
      return null;
    }
    if (isDesign) {
      return this.resolveDesignHost(layoutModel, dynamicControlContainer);
    } else {
      // this.setLayoutModelDefault(layoutModel);
      return this.resolveControl(this.componentFactoryResolver, layoutModel, dynamicControlContainer, isDesign);
    }
  }

  resolveDesignHost(layoutModel: ControlLayoutModel, dynamicControlContainer: DynamicControlContainer) {
    const viewContainerRef = dynamicControlContainer.layoutHost.viewContainerRef;

    const hostComponentFactory = this.componentFactoryResolver.resolveComponentFactory(DesignHostComponent);
    const hostComponentRef = viewContainerRef.createComponent(hostComponentFactory);

    const instance = hostComponentRef.instance;
    instance.controlTranslate = this;
    instance.componentRef = hostComponentRef;
    instance.parentHost = dynamicControlContainer;

    // set parent
    if (dynamicControlContainer instanceof AbstractControlContainerComponent) {
      instance.parent = dynamicControlContainer;
    }

    instance.addControl(layoutModel);
    return instance;
  }

  resolveControl(
    componentFactoryResolver: ComponentFactoryResolver,
    layoutModel: ControlLayoutModel,
    controlLayoutHost: ControlLayoutHost,
    isDesign?: boolean
  ): AbstractControl<ControlViewModel> {
    const componentFactory = componentFactoryResolver.resolveComponentFactory(layoutModel.component);
    const componentRef = controlLayoutHost.layoutHost.viewContainerRef.createComponent(componentFactory);
    const instance = <AbstractControl<ControlViewModel>>componentRef.instance;
    instance.isDesign = isDesign === undefined ? true : isDesign;
    instance.model = layoutModel.model;

    // designHoståä¸é¢çæ§ä»¶æå±åçparent
    if (controlLayoutHost instanceof AbstractControlContainerComponent) {
      if (controlLayoutHost instanceof DesignHostComponent) {
        instance.parent = controlLayoutHost.parent;
      } else {
        instance.parent = controlLayoutHost;
      }
    }

    this.controlResolved.next(instance);

    const container = <AbstractControlContainerComponent<any>>componentRef.instance;
    if (container.isContainer && layoutModel.children) {
      container.controlTranslate = this;
      container.addControls(layoutModel.children);
    }

    return instance;
  }

  /**
   * è¿æ»¤æ ä¸æ¾ç¤ºçæ§ä»¶
   *
   */
  filterNotDisplayControl(controlDataModels: Array<ControlDataModel>): Array<ControlDataModel> {
    return controlDataModels;
  }
}
